/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Logo from '../Logo';
import usageTracker from '../../lib/usageTracker';
import ErrorDetails from './ErrorDetails';
import { getDomain } from '../../selectors/Grader';
import SingleColumnLayout from '../layouts/SingleColumnLayout';
import { ThemedErrorPage } from '../../theming/components/ThemedErrorPage';
import Footer from '../footer/Footer';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (() => {
  const domain = useSelector(getDomain);
  useEffect(() => {
    if (domain) {
      usageTracker.logView('Error');
    }
  }, []);
  return /*#__PURE__*/_jsx(ThemedErrorPage, {
    children: /*#__PURE__*/_jsxs(SingleColumnLayout, {
      className: "error-page",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "WIDGET_ERROR_PAGE_LOADED"
      }), /*#__PURE__*/_jsx(ResultHeaderIllustration, {
        name: "map",
        width: "150px"
      }), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx("div", {
        className: "title",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "meta.title"
        })
      }), /*#__PURE__*/_jsx(ErrorDetails, {}), /*#__PURE__*/_jsx(Footer, {})]
    })
  });
});